import React from 'react'

import RedirectJT from '../components/login-modal/RedirectJT'

const RedirectJTScreen = props => <RedirectJT {...props} />

export default RedirectJTScreen
